module.exports = __webpack_public_path__ + "static/media/TIGOTA.429236d1.svg";